import { Component } from '@angular/core';

import { HomePageComponent } from '@frontend/vanilla/features/home-page';

import { HomePageConfig } from '../client-config/client-config.models';
import { HomeComponent } from './home.component';

@Component({
    selector: 'pt-home-selector',
    templateUrl: 'home-selector.component.html',
    imports: [HomePageComponent, HomeComponent],
})
export class HomeSelectorComponent {
    constructor(public config: HomePageConfig) {}
}
